module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "CTA"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageix",
      "title": "ix"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "CFMH",
    attrs: {
      "id": "cover"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagex",
      "title": "x"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/Cover"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH",
    attrs: {
      "id": "title"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Titlepage"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH",
    attrs: {
      "id": "ded"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Dedication"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH",
    attrs: {
      "id": "epi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Epigraph"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH2",
    attrs: {
      "id": "fore"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Foreword"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Foreword: This Scept’red Aisle")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "chap01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch01"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Childe Harry")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "chap02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Hollywood Royalty")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "chap03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Goodbye, Mummy")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "chap04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("[You Gotta Have] Heart")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "chap05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The Playing Fields of Eton: Acting Out")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "chap06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Fitting in a Box: Acting")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "chap07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Attention Must Be Paid: Growing Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "chap08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Uniforms: You’re in the Army Now")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "chap09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Moving On and Moving Out: "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Suits")]), _vm._v(" and Charities Abroad")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "chap10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Charities Begin at Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "chap11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("When Harry Met Meghan")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "chap12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Harry Hitches His Wagon to a Star")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT",
    attrs: {
      "id": "chap13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("American Princess")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMHF",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH",
    attrs: {
      "id": "ata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ATA",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH",
    attrs: {
      "id": "copy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH",
    attrs: {
      "id": "atp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ATP",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("About the Publisher")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0388b1f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Contents.vue
// module id = 69
// module chunks = 0